import { collection, addDoc, getDocs, query, orderBy, limit, startAfter } from "firebase/firestore"; 
import { firebaseStore } from "util/firebaseUtil";

export const placeListFirstReadDocument = async (keyword: string, orderby?: any, lim?: any) => {
  const que = query(
      collection(firebaseStore, keyword), 
      orderBy(orderby),
      limit(lim)
    )
  return await getDocs(que);
}

export const placeListReadDocument = async (keyword: string, orderby?: any, startafter?: any, lim?: any) => {
  const que = query(
      collection(firebaseStore, keyword), 
      orderBy(orderby),
      startAfter(startafter),
      limit(lim)
    )
  return await getDocs(que);
}